// extracted by mini-css-extract-plugin
module.exports = {"main":"Button_main__2K8b3","mainIconButton":"Button_mainIconButton__3FQ2B","loaderSpan":"Button_loaderSpan__2Vwmq"};